module.exports = __webpack_public_path__ + "media/images/map-marker-055be35780c38d0aa90d90afce01eafa.png";